import { uniq } from 'es-toolkit';

export function hasAll<T>(array: readonly T[], values: readonly T[]) {
  return values.every((value) => array.includes(value));
}

export function hasSome<T>(array: readonly T[], values: readonly T[]) {
  return values.some((value) => array.includes(value));
}

export function hasOnlySome<T>(array: readonly T[], values: readonly T[]) {
  return hasSome(array, values) && !hasAll(array, values);
}

export function addMany<T>(array: readonly T[], values: readonly T[]) {
  return uniq([...array, ...values]);
}

export function removeMany<T>(array: readonly T[], values: readonly T[]) {
  return array.filter((value) => !values.includes(value));
}

export function toggle<T>(array: readonly T[], value: T) {
  return array.includes(value) ? array.filter((v) => v !== value) : [...array, value];
}

export function toggleManyTogether<T>(array: readonly T[], values: readonly T[]) {
  return hasAll(array, values) ? removeMany(array, values) : addMany(array, values);
}
